export enum JobStatus {
    RUNNING,
    IDLE
}

export interface Location {
    name: string,
    vetSourceId: string,
    netSuiteId: number,
    acquiredOn: Date,
    startedOn: Date,
    active: boolean
}

export interface JobHistory {
    id: number
    locationName: string,
    transactionDate: Date,
    status: string,
    error: string,
    type: string,
    totalAmt: number,
    successAmt: number,
    failedAmt: number,
    createdAt: Date,
    jobHistoryEntries: JobHistoryEntry[],
    loading: boolean
}

export interface JobHistoryEntry {
    transactionDate: Date,
    status: string,
    error: string,
    createdAt: Date
}
